import { Injectable } from '@angular/core';
import { CustomGroup } from 'models/custom-loa-group.model';
import { AuthService } from '../services/auth.service';
import { ApiClientService } from './common/api-client.service';
import { CustomGroupAssignment } from 'models/custom-group-assignment.model';
import { ContactAssignment } from 'models/assign-contact.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { AddressValidation } from 'models/contactcode.model';
import { State } from '../models';
import { UserPersonalInfo } from '../models/onboarding/personal-info-data.model';
import { EmailNotificationFilter } from 'models/email-notification.model';
import { WritingCodeNotes, WritingCodeRequest } from '../models/user-carrier-details.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  public contactList: BehaviorSubject<any> = new BehaviorSubject([]);
  
  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService) { }

    public getContactList(contactList: boolean) { //the component that wants to update something, calls this fn
      this.contactList.next(contactList); //next() will feed the value in Subject
    }

  sendInvitation(requestObject: any) {
    return this.apiClient.post(`api/Contact/sendinvitation`, requestObject, null, true);
  }

  updateRole(requestObject: any) {
    return this.apiClient.post(`api/Contact/changerole`, requestObject, null, true);
  }

  post(requestObject: any) {
    return this.apiClient.post(`api/Contact`, requestObject, null, false);
  }

  put(requestObject: any) {
    return this.apiClient.put(`api/Contact`, requestObject, null, false);
  }

  //delete(id: number) {
  //    return this.apiClient.delete(`api/Contact/${id}`, null, null, false);
  //}
  delete(requestObject: any) {
    return this.apiClient.post(`api/Contact/deletecontact`, requestObject, null, true);
  }

  getAll(value) {
    return this.apiClient.get(`api/Contact`, null, null, false);
  }

  getById(id: number, tenantId: number) {
    return this.apiClient.get(`api/Contact/${id}/${tenantId}`, null, null, false);
  }

  //public listContactByTenant(tenantId: number, pageNum: number, pageSize: number, search: string) {
  public listContactByTenant(search: any, showloader: boolean = true) {
    return this.apiClient.post(`api/contact/listcontact`, search, null, showloader);
  }

  getContactDashboardDetail(request,showLoading = true) {
    return this.apiClient.post(`api/Contact/ContactDashboard`, request, null, showLoading);
  }

  getContactDashboardCount(request,showLoading = true) {
    return this.apiClient.post(`api/Contact/getContactDashboardCount`, request, null, showLoading);
  }

  //Unused
  getTenantSubscriptionDetail(tenantId: number) {
    return this.apiClient.get(`api/Payment/tenantsubscriptiondetails/${tenantId}`, null, null, true);
  }

  assignCustomGroups(customGroupAssignment: CustomGroupAssignment) {
    return this.apiClient.post(`api/Contact/assignCustomGroups`, customGroupAssignment, null, true);
  }

  sendNotification(tenantId: number, userLicenses: string) {
    return this.apiClient.post(`api/ExpiringLicenseNotification/userExpiredlicense/${tenantId}/${userLicenses}`, null, null, true);
  }

  getTenantContactCount(tenantId: number) {
    return this.apiClient.get(`api/Contact/getTenantContactCount/${tenantId}`, null, null, true);
  }

  getUserAddresslist(userId: number) {
    return this.apiClient.get(`api/Contact/getUserAddresslist/${userId}`, null, null, true);
  }

  assignContacts(contactAssignment) {
    return this.apiClient.post(`api/Contact/assignContacts`, contactAssignment, null, true);
  }

  public getContactLicenseClassList(contactId: number) {
    return this.apiClient.get(`api/Contact/ContactLicenseClassListForFileUpload/${contactId}`, null, null, true);
  }

  createAddressChangeRequest(payload: any) {
    return this.apiClient.post(`api/Contact/createAddressChangeRequest`, payload, null, true);
  }

  getCountyListByStateCode(stateCode: string) {
    return this.apiClient.get(`api/Contact/getCountyListByStateCode/${stateCode}`, null, null, false);
  }

  getResidenceStateOfUser(userId: number, tenantId: number, showLoading = true): Observable<State> {
    return this.apiClient.get(`api/Contact/getResidenceStateOfUser/${userId}/${tenantId}`, null, null, showLoading);
  }

  //getResidenceStateUserLicenses(userId: number, tenantId: number) {
  //  return this.apiClient.get(`api/NewLicenseRequest/getUserResidentStateLicenses/${tenantId}/${userId}`, null, null, true);
  //}

  getStatesToSkip(tenantId: number) {
    return this.apiClient.get(`api/Contact/getStatesToSkip/${tenantId}`, null, null, true);
  }

  // Firm Dashboard
  getFirmDashboardDetail(request) {
    return this.apiClient.post(`api/branch/FirmDashboard`, request, null, true);
  }

  archiveContact(requestObject: any) {
    return this.apiClient.post(`api/Contact/archiveContact`, requestObject, null, true);
  }

  public listArchivedContactByTenant(search: any) {
    return this.apiClient.post(`api/contact/listArchivedContactByTenant`, search, null, true);
  }

  unarchiveContact(requestObject: any) {
    return this.apiClient.post(`api/Contact/unarchiveContact`, requestObject, null, true);
  }

  downloadBulkImportTemplate() {
    return this.apiClient.exportGet(`api/Contact/downloadBulkImportTemplate`, null, null, true);
  }

  updateUserAlias(requestObject: any) {
    return this.apiClient.post(`api/Contact/updateUserAlias`, requestObject, null, false);
  }

  updateUserProducerCode(requestObject: any) {
    return this.apiClient.post(`api/Contact/updateUserProducerCode`, requestObject, null, false);
  }

  updateUserProfileInformation(requestObject: any) {
    return this.apiClient.post(`api/Contact/updateUserProfileInformation`, requestObject, null, false);
  }

  updateUserSSN(requestObject: any) {
    return this.apiClient.post(`api/Contact/insertUpdateUserSSN`, requestObject, null, false);
  }

  updateUserDOB(requestObject: any) {
    return this.apiClient.post(`api/Contact/insertUpdateUserDOB`, requestObject, null, false);
  }

  getTenantJobTitles(tenantId: number, showLoading = true) {
    return this.apiClient.get(`api/Tenant/getJobTitlesByTenant`, null, null, showLoading);
  }

  getTenantDepartment(tenantId: number, showLoading = true) {
    return this.apiClient.get(`api/Tenant/getDepartmentsByTenant`, null, null, showLoading);
  }

  getContactCEDetails(search: any) {
    return this.apiClient.post(`api/contact/contactCEDetailsList`, search, null, true);
  }

  updateUserCEDetails(requestObj: any) {
    return this.apiClient.post(`api/Contact/updateUserCEDetails`, requestObj, null, true);
  }

  getStateWiseCETypeList(stateCode: string) {
    return this.apiClient.get(`api/contact/ceTypeList/${stateCode}`, null, null, false);
  }

  addNewContactCEDetails(obj: any) {
    return this.apiClient.post(`api/Contact/insertUserCEDetails`, obj, null, true);
  }

  uploadBulkImportFile(formData: FormData): Observable<any> {
      const header = new HttpHeaders().append(
        "Content-Disposition",
        "multipart/form-data"
    );
    return this.apiClient.uploadFile(`api/contact/uploadBulkImportFile`, formData, header);
  }

  public getUser(userId: number) {
    return this.apiClient.get(`api/user/userdetail/${userId}`, null, null, false);
  }  

  producerLincenseExpireEmailNotificationList( emailNotificationFilter:EmailNotificationFilter ,  showLoading = true) {
    return this.apiClient.post(`api/Contact/producerLincenseExpireEmailNotificationList`,emailNotificationFilter,null, showLoading);
  }

  adminLincenseExpireEmailNotificationList(emailNotificationFilter:EmailNotificationFilter,showLoading = true) {
    return this.apiClient.post(`api/Contact/adminLincenseExpireEmailNotificationList`, emailNotificationFilter, null, showLoading);
  }

  producerLicenseExpireEmailNotificationDetails(emailNotificationLogId : number) {
    return this.apiClient.get(`api/Contact/producerLicenseExpireEmailNotificationDetails/${emailNotificationLogId}`,null, null, false);
  }

  updateAdminRoleToContact(requestObject: any) {
    return this.apiClient.post(`api/Contact/updateAdminRoleToContact`, requestObject, null, true);
  }

  uspsAddressValidation(requestObject: AddressValidation) {
    return this.apiClient.post(`api/USPSValidation/validateAddress`, requestObject, null, true);
  }

  getActiveContactListByTenantId(showLoading: boolean = true) {
    return this.apiClient.get(`api/Contact/getActiveContactListByTenantId`, null, null, showLoading);
  }

  public exportContactList(search: any) {
    return this.apiClient.export('api/Contact/contactList/Export', search, null, true);
  }

  createPIIViewEntry(requestObject: any) {
    return this.apiClient.post(`api/AdminDashboard/createPIIViewEntry`, requestObject, null, false);
  }

  getUserSSN(contactId) {
    return this.apiClient.get(`api/Contact/getUserSSN/${contactId}`, null, null, false);
  }
  getUserDOB(contactId) {
    return this.apiClient.get(`api/Contact/getUserDOB/${contactId}`, null, null, false);
  }
  updateProfileStatus(tenantId: number, profileStatus: number){
     return this.apiClient.post(`api/Contact/updateTenantProfileStatus/${tenantId}/${profileStatus}`,null, null, false);
  }
  GetUserPersonalInfoData() {
    return this.apiClient.get("api/Contact/GetUserPersonalInfoData", null, null, false);
  }
  InsertUpdateUserPersonalInfo(userPersonalInfo: UserPersonalInfo) {
    return this.apiClient.post(`api/contact/InsertUpdateUserPersonalInfo`, userPersonalInfo, null, false);
  }
  UpdateUserPhoneNumber(updateProfileInformation: any) {
    return this.apiClient.post(`api/contact/UpdateUserPhoneNumber`, updateProfileInformation, null, false);
  }
  public listDeletedContactByTenant(search: any) {
    return this.apiClient.post(`api/Contact/listDeletedContactByTenant`, search, null, true);
  }
  getUserStatus(contactId: number, showloading:boolean = true) {
    return this.apiClient.get(`api/Contact/GetUserStatus/${contactId}`, null, null, showloading);
  }
  GetUserBackgroundAndEmploymentHistoryStatus(contactId: number) {
    return this.apiClient.get(`api/Contact/GetUserBackgroundAndEmploymentHistoryStatus?userId=${contactId}`, null, null, false);
  }

  reactivateContact(requestObject: any[]) {
    return this.apiClient.post(`api/contact/reactivate`, requestObject, null, false);
  }

  getProgress(jobId: string) {
    return this.apiClient.get(`api/contact/progress/${jobId}`,null, null,false);
  }

  cleanup(jobId: string) {
    return this.apiClient.get(`api/contact/cleanup/${jobId}`);
  }
  // Not currently in use; reserved for displaying the last updated date on the contact dashboard using sepqrate API call instead of including it in the contact dashboard details response
  // getLatestDateByTenant(contactId: number){
  //   return this.apiClient.get(`api/contact/getLatestDateByTenant/${contactId}`);
  // }


  getIsDHSUser(userId: number) {
    return this.apiClient.get(`api/contact/getIsDHSUser/${userId}`,null, null,false);
  }

  public getUserInfo(userId: number) {
    return this.apiClient.get(`api/user/userInfo/${userId}`, null, null, false);
  }
  public insertUpdateWritingCode(requestObject: WritingCodeRequest) {
    return this.apiClient.post(`api/carrier/insertUpdateWritingCode`, requestObject, null, false);
  }
  public insertWritingCodeNote(requestObject: WritingCodeNotes) {
    return this.apiClient.post(`api/carrier/insertWritingCodeNote`, requestObject, null, false);
  }
  public getWritingCodeNotes(userId: number, carrierId: number) {
    return this.apiClient.get(`api/carrier/getWritingCodeNotes/${userId}/${carrierId}`, null, null, false);
  }
  public getWritingCodeDetails(writingCodeId: number) {
    return this.apiClient.get(`api/carrier/getWritingCodeDetails/${writingCodeId}`, null, null, true);
  }
}
